import { ConsentDataResourceScope } from "healthex-common/consentscopes.dtos";
import { ParameterizedPagedRemoteData } from "../Infra/RemoteData";
const PAGE_SIZE = 100;
export class SHLUIManager {
    constructor(invalidationManager, shlService, authManager) {
        this.invalidationManager = invalidationManager;
        this.shlService = shlService;
        this.authManager = authManager;
        this.patientSHLsForSearch = new ParameterizedPagedRemoteData(this.invalidationManager, PAGE_SIZE, () => ({}), () => this.loadPatientSHLs());
    }
    static removeImpliedScopes(scopes) {
        if (!scopes) {
            return [];
        }
        if (scopes.includes(ConsentDataResourceScope.DEMOGRAPHICS) && scopes.includes(ConsentDataResourceScope.CONTACT_INFO)) {
            return scopes.filter((scope) => scope !== ConsentDataResourceScope.CONTACT_INFO);
        }
        return scopes;
    }
    async loadPatientSHLs() {
        const patientId = this.authManager.id;
        if (!patientId) {
            return { results: [], total: 0 };
        }
        const shls = await this.shlService.getSHLsForPatient(patientId);
        return {
            results: shls,
            total: shls.length,
        };
    }
}
